export default "__VITE_ASSET__C8Tl60aq__"